import { getContentLength } from 'ricos-content/libs/getContentLength';
import { extract } from 'ricos-content/libs/extract';
import { Decoration_Type, Node_Type } from 'ricos-schema';
import { ReactionCodeValue as ReactionCode } from '../../reactions/constants';
import { isDefined } from '../../ts-utils';
export const ReactionCodeBIMap = {
    [ReactionCode.ANGRY]: 'angry',
    [ReactionCode.LIKE]: 'like',
    [ReactionCode.HAHA]: 'haha',
    [ReactionCode.SAD]: 'sad',
    [ReactionCode.WOW]: 'wow',
    [ReactionCode.CLAP]: 'clap',
    [ReactionCode.THUMBS_UP]: 'thumbs_up',
    [ReactionCode.THINKING]: 'thinking',
    [ReactionCode.LOVE]: 'love',
    [ReactionCode.SMILE]: 'smile',
};
export const getTextCharCount = (content) => {
    return getContentLength(content);
};
export const getContentEntityData = (content) => {
    const mentionCount = getDecorationsCount(content, Decoration_Type.MENTION);
    const imageCount = getNodeCount(content, Node_Type.IMAGE);
    const fileCount = getNodeCount(content, Node_Type.FILE);
    const quoteCount = getNodeCount(content, Node_Type.BLOCKQUOTE);
    const videoCount = getNodeCount(content, Node_Type.VIDEO);
    const gifCount = getNodeCount(content, Node_Type.GIF);
    const galleryCount = getNodeCount(content, Node_Type.GALLERY);
    return {
        /*
          it's not possible to parse new Ricos Content for emojis and hashtags to determine their count
        */
        has_emoji: false,
        has_hashtag: false,
        hashtag_count: 0,
        has_mention: Boolean(mentionCount),
        has_image: Boolean(imageCount),
        has_video: Boolean(videoCount),
        is_custom_video: Boolean(videoCount && hasCustomRichContentVideo(content)),
        has_quote: Boolean(quoteCount),
        has_gif: Boolean(gifCount),
        has_gallery: Boolean(galleryCount),
        image_in_gallery_count: getGalleryItemsInRichContentCount(content),
        mention_count: mentionCount,
        image_count: imageCount,
        file_count: fileCount,
        media_source: determineRichContentMediaSource(content),
    };
};
export const getTabName = (tabName) => {
    switch (tabName) {
        case ReactionCode.ANGRY:
            return 'angry';
        case ReactionCode.HAHA:
            return 'haha';
        case ReactionCode.LIKE:
            return 'like';
        case ReactionCode.SAD:
            return 'sad';
        case ReactionCode.WOW:
            return 'wow';
        default:
            return 'all';
    }
};
const getDecorationsCount = (content, decorationType) => {
    return extract(content.nodes)
        .filter(({ nodes }) => !!nodes)
        .map(({ nodes }) => nodes.map(({ textData }) => textData?.decorations.filter(({ type }) => type === decorationType)))
        .filter((decorations) => decorations.length > 0)
        .get()
        .flat(Infinity)
        .filter(isDefined).length;
};
const getNodeCount = (content, nodeType) => {
    return extract(content.nodes)
        .filter(({ type }) => type === nodeType)
        .get().length;
};
const hasCustomRichContentVideo = (content) => {
    return (extract(content.nodes)
        .filter(({ type, videoData }) => type === Node_Type.VIDEO && !!videoData?.video?.src?.url)
        .get().length > 0);
};
const hasEmbededRichContentVideo = (content) => {
    return (extract(content.nodes)
        .filter(({ type, videoData }) => type === Node_Type.VIDEO && !!videoData?.video?.src?.id)
        .get().length > 0);
};
const getGalleryItemsInRichContentCount = (content) => {
    return extract(content.nodes)
        .map(({ galleryData }) => galleryData?.items || [])
        .map((items) => items.filter(({ image }) => !!image).length)
        .get()
        .reduce((sum, count) => sum + count, 0);
};
const determineRichContentMediaSource = (content) => {
    const videoCount = getNodeCount(content, Node_Type.VIDEO);
    const isCustom = hasCustomRichContentVideo(content);
    const isLinked = hasEmbededRichContentVideo(content);
    if (videoCount === 0) {
        return null;
    }
    if (isCustom && isLinked) {
        return 'mixed';
    }
    return isCustom ? 'file' : 'link';
};
//# sourceMappingURL=bi-utils.js.map